<template>
  <div class="flex items-center">
    <div class="h-10 w-14 flex-shrink-0">
      <img
        class="h-10 w-14 object-cover rounded-sm"
        :src="place.image"
        :alt="place.name"
      >
    </div>
    <div class="ml-4">
      <div class="font-medium text-gray-900 ">
        {{ place.name }}
      </div>
      <div class="text-gray-500">
        {{ place.area }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Place',
  components: {},
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>

</style>
